/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderDTO
 */
export interface ProviderDTO {
    /**
     * 
     * @type {number}
     * @memberof ProviderDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProviderDTO
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderDTO
     */
    used?: boolean;
}

export function ProviderDTOFromJSON(json: any): ProviderDTO {
    return ProviderDTOFromJSONTyped(json, false);
}

export function ProviderDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'used': !exists(json, 'used') ? undefined : json['used'],
    };
}

export function ProviderDTOToJSON(value?: ProviderDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'used': value.used,
    };
}

